/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import Calendar from "components/Calendar/Calendar.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import Datetime from 'react-datetime';

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSCheckBox from "components/Forms/TSCheckBox";
import TSSelect2 from "components/Forms/TSSelect2";
import { Collapse, Modal, ModalBody } from "reactstrap";
import loading from "assets/img/loading-load.gif";

import TSUser from "components/Forms/TSUser";
// import avatar from "assets/img/faces/marc.jpg";
import {
    Input,
    Label,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

import styled from "styled-components";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const _color = [{ id: 1, forecolor: '#3788d8' }, { id: 2, forecolor: '#0E6251' }, { id: 3, forecolor: '#9A7D0A' }, { id: 4, forecolor: '#8E44AD' }, { id: 5, forecolor: '#E67E22' }, { id: 6, forecolor: '#6D4C41' }]

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);


const Admin = (props) => {
    var moment = require('moment');
    require('moment/locale/th');
    const [leaveAll, setLeaveAll] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [DefaultDate, setDefaultDate] = useState(moment().format("YYYY-MM-DD"));
    const [LeaveTypeKey, setLeaveTypeKey] = useState(0);
    const [ArrLeave, setArrLeave] = useState([]);
    const [modal, setModal] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [isOpen, setIsOpen] = useState(false);
    const [isShowCalendar, setIsShowCalendar] = useState(true);

    const urgentList = [{ label: "ปกติ", value: 0 }, { label: "ด่วน", value: 1 }, { label: "ฉุกเฉิน", value: 2 }];
    const dateTypeList = [{ label: "ทั้งวัน", value: 0 }, { label: "ครึ่งวันเช้า", value: 1 }, { label: "ครึ่งวันบ่าย", value: 2 }];

    const myRef = useRef(null);

    var calendarRef = React.createRef();

    useEffect(() => {
      if (DefaultDate != null && DefaultDate != '')
      {
        let calendarApi = calendarRef.current.getApi();
        calendarApi.gotoDate(DefaultDate);
      }
    },[DefaultDate]);
  

    useEffect(() => {
        axios("/api/v1/leave/leavetypeall")
        .then(
            result => {
                var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"leaveTypeKey":').join('"value":'));
                setArrLeave(json)
                getMeeting()
            }, error => { console.log(error); }
        );
    }, [])

    useEffect(() => {
        setIsLoading(true);
        axios.get("/api/v1/leave/header/" + "?LeaveTypeKey=" + LeaveTypeKey)
        .then(
            result => {
                var json = JSON.parse(JSON.stringify(result.data).split('"leaveDesc":').join('"title":').split('"startDate":').join('"start":')
                    .split('"endDate":').join('"end":').split('"leaveRequestID":').join('"id":'));
                if (json.length >= 0) {
                    setLeaveAll(json);
                    setIsLoading(false);
                }
            },
            error => { alert(error); }
        );
      },[LeaveTypeKey]);


    const getMeeting = () => {
        setIsLoading(true);
        axios.get('/api/v1/leave/header/')
            .then(
                result => {
                    var json = JSON.parse(JSON.stringify(result.data).split('"leaveDesc":').join('"title":').split('"startDate":').join('"start":')
                        .split('"endDate":').join('"end":').split('"leaveRequestID":').join('"id":'));
                    if (json.length >= 0) {
                        setLeaveAll(json);
                        setIsLoading(false);
                    }

                },
                error => { alert(error); }
            );
    }

    const handleConfirm = evt => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    };

    const handleDateClick = (args) => {
        setDefaultDate(args.dateStr);
    };

    const handleEventClick = (args) => {
        setDefaultDate(moment(args.event.start).format('YYYY-MM-DD'))
    };

     const handleEventClickList = e => {
         if (e.event._def.publicId != null && e.event._def.publicId != '') {
            props.history.push({
                 pathname: 'id/'+e.event._def.publicId,
             })
         }
     }

    const classes = useStyles();
    return (

        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <Grid>
                                <Col xs={12} sm={12} md={3}>
                                    <h4 className={classes.cardTitleWhite}>ปฏิทินการลา</h4>
                                </Col>
                                <Col xs={6} sm={6} md={6} style={{ color: 'black', textAlign: 'left' }}>
                                {/* {isShowCalendar ? */}
                                    <TSSelect2 label="" options={ArrLeave} value={LeaveTypeKey} onChange={e => setLeaveTypeKey(e.value)} />
                                    {/* : <></>
                                } */}
                                </Col>
                                <Col xs={6} sm={6} md={3} style={{ textAlign: 'right' }}>
                                    <TSCheckBox checked={isShowCalendar} onChange={e => setIsShowCalendar(!isShowCalendar)} /> {(isShowCalendar) ? <span style={{ color: 'white' }} >แสดงปฏิทิน </span> : <span style={{ color: 'white' }}>แสดงรายการ </span>}
                                </Col>
                            </Grid>
                        </CardHeader>
                        <CardBody>
                            {(!isShowCalendar) ?
                                <Grid>
                                    <Col xs={12} sm={12} md={12}>
                                        <Fullcalendar
                                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
                                            initialView={"listWeek"}
                                            headerToolbar={{
                                                start: "listDay,listWeek,listMonth", // will normally be on the left. if RTL, will be on the right
                                                center: "title",
                                                end: "today prev,next", // will normally be on the right. if RTL, will be on the left
                                            }}
                                            views={{
                                                listDay: { buttonText: 'วัน' },
                                                listWeek: { buttonText: 'สัปดาห์' },
                                                listMonth: { buttonText: 'เดือน' }
                                            }}
                                            hiddenDays={[0, 6]}
                                            height={"100vh"}
                                            //dateClick={handleDateClick}
                                            events={leaveAll}
                                            droppable={true}
                                            rerenderDelay={10}
                                            eventDurationEditable={false}
                                            eventClick={handleEventClickList}
                                            locale={'th'}
                                            eventContent={renderEventContent2}
                                            displayEventTime={false}
                                        />
                                    </Col>
                                </Grid>
                                :
                                <Grid>
                                    {isLoading && (
                                        <>
                                        <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                                            <img style={{ width: "50%" }} src={loading} alt="..." />
                                        </Col>
                                        </>
                                    )}
                                    { !isLoading && ( <>
                                    <Col xs={12} sm={12} md={6}>
                                        <div style={{ textAlign: 'center' }}>
                                            <Fullcalendar
                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                initialView={"dayGridMonth"}
                                                headerToolbar={{
                                                    start: "title", // will normally be on the left. if RTL, will be on the right
                                                    center: "",
                                                    end: "today prev,next", // will normally be on the right. if RTL, will be on the left
                                                }}
                                                hiddenDays={[0, 6]}
                                                height={"100vh"}
                                                dateClick={handleDateClick}
                                                events={leaveAll}
                                                droppable={true}
                                                rerenderDelay={10}
                                                eventDurationEditable={false}
                                                //editable={true}
                                                //eventClick={}
                                                eventClick={handleEventClick}
                                                locale={'th'}
                                                eventContent={renderEventContent}
                                                displayEventTime={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} style={{ marginTop: "20px" }}>
                                        <Fullcalendar
                                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
                                            initialDate={DefaultDate}
                                            ref={calendarRef}
                                            initialView={"listDay"}
                                            headerToolbar={{
                                                start: "", // will normally be on the left. if RTL, will be on the right
                                                center: "title",
                                                end: "", // will normally be on the right. if RTL, will be on the left
                                            }}
                                            views={{
                                                listDay: { buttonText: 'วัน' }
                                            }}
                                            hiddenDays={[0, 6]}
                                            height={"100vh"}
                                            //dateClick={handleDateClick}
                                            events={leaveAll}
                                            droppable={true}
                                            rerenderDelay={10}
                                            eventDurationEditable={false}
                                            eventClick={handleEventClickList}
                                            locale={'th'}
                                            eventContent={renderEventContent2}
                                            displayEventTime={false}
                                        />
                                    </Col></>)
                                    }
                                    {/* <Col xs={12} sm={12} md={12}>
                                        <Calendar
                                            defaultDate={DefaultDate} customHeader={'ห้องประชุม 1'} id={1}
                                            events={room1}
                                            />
                                    </Col> */}
                                </Grid>
                            }
                        </CardBody>
                        <CardFooter>
                            <Collapse isOpen={isOpen}>
                            </Collapse>
                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModal(false)}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>

                            {/* Error */}
                            <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className="fa fa-times"
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                    <div>{errMsg}</div>
                                </ModalBody>
                                <div className="modal-footer justify-content-center">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalError(false)}
                                    >
                                        <h4>ตกลง</h4>
                                    </Button>
                                </div>
                            </Modal>
                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );


    function renderEventContent(eventInfo) {

        const _c = _color.find(c => c.id === eventInfo.event.extendedProps.leaveTypeKey);
        const colorTxt = (_c !== undefined) ? ((eventInfo.event.extendedProps.isCancel == true) ? 'red' : _c.forecolor) : '#000000';
        const strikeTxt = (eventInfo.event.extendedProps.isCancel == true) ? 'line-through' : '';

        return (
            <>
                <div className="fc-event-time" 
                 style={{ color: colorTxt, textDecoration: strikeTxt }}
                > {eventInfo.timeText}</div>
                <div className="fc-event-title" 
                 style={{ color: colorTxt, textDecoration: strikeTxt }}
                > {eventInfo.event.title}</div>
            </>
        )
    }

    function renderEventContent2(eventInfo) {

        const _c = _color.find(c => c.id === eventInfo.event.extendedProps.leaveTypeKey);
        // const _room = ArrRoom.find(c => c.value === eventInfo.event.extendedProps.leaveTypeKey);

        const colorTxt = (_c !== undefined) ? ((eventInfo.event.extendedProps.isCancel == true) ? 'red' : _c.forecolor) : '#000000';
        // const roomTxt = (_room !== undefined) ? _room.label : '';
        const strikeTxt = (eventInfo.event.extendedProps.isCancel == true) ? 'line-through' : '';

        return (
            <>
                {/* <div className="fc-event-title" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.event.title} {roomTxt}</div> */}
                <div className="fc-event-title" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.event.title} </div>
            </>
        )
    }
}

export default Admin;